import React from 'react';
import axios from 'axios';
import { ButtonGroup, Button, Modal, Glyphicon, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import AddListwaModal from './AddListwa';
import UpdateListwaModal from './UpdateListwa';
import {isLoggedIn, ifMagazyn, ifAdmin, ifSprzedawca } from '../../utils/AuthService';

var StanListwy = React.createClass({

	getInitialState: function() {
		return {
			data: null,
			selectedListwaId: null,
			showAddModal: false,
			showUpdateModal: false
		}
    },

	componentDidMount: function() {
		this.refreshTable();
	},

	render: function() {

		var selectRowProp = {
			mode: "radio",
			clickToSelect: true,
			className: "selected-row",
			bgColor: 'rgb(101, 148, 255)',
			onSelect: this.onRowSelect
		};

		if(!isLoggedIn()){
			return (<div></div>);
		};

		return (
			<div>
				<ButtonGroup className="m-10">
					<Button bsStyle="primary" disabled={ifMagazyn()} onClick={this.openAddModal}><Glyphicon glyph="plus" />Dodaj listwę</Button>
					<Button bsStyle="warning" disabled={this.state.selectedListwaId === null && (ifAdmin() || ifMagazyn())} onClick={this.openUpdateModal}><Glyphicon glyph="refresh" />Aktualizuj</Button>
					<Button bsStyle="danger" disabled={this.state.selectedListwaId === null && (ifAdmin() || ifMagazyn()) } onClick={this.onDeleteBtnClicked}><Glyphicon glyph="trash" />Usuń</Button>
				</ButtonGroup>

				<BootstrapTable data={this.state.data}
					striped={true}
					hover={true}
					pagination={true}
					search={true}
					selectRow={selectRowProp}>
						<TableHeaderColumn dataField="id" isKey={true} dataSort={true}>ID</TableHeaderColumn>
						<TableHeaderColumn dataField="numerListwy" dataSort={true}>Numer listwy</TableHeaderColumn>
						<TableHeaderColumn dataField="iloscCm" dataSort={true}>Ilosc cm</TableHeaderColumn>
						<TableHeaderColumn dataField="ilot" dataSort={true}>Ilot</TableHeaderColumn>
			 </BootstrapTable>

				<AddListwaModal parent={this} ref="addListwa" />
				<UpdateListwaModal parent={this} ref="updateListwa"/>

			</div>
		);
	},

	onRowSelect: function(row, isSelected) {
		if(isSelected) {
			this.setState({ selectedListwaId: row.id });
		}else {
			this.setState({ selectedListwaId: null });
		}
	},

	closeAddModal: function() {
		this.setState({ showAddModal: false });
		this.refs.addListwa.clearAddObject();
	},

	openAddModal: function() {
		this.refs.addListwa.clearAddObject();
		this.setState({ showAddModal: true });
	},

	closeUpdateModal: function() {
		this.setState({showUpdateModal: false});
		this.refs.updateListwa.clearUpdateObject();
	},

	openUpdateModal: function() {
		this.refs.updateListwa.fillUpdateObject();
		this.setState({showUpdateModal: true});
	},

	onDeleteBtnClicked: function() {

		axios.delete('http://217.182.200.222:8080/stanListwy/' + this.state.selectedListwaId)
			.then(function (response) {
				this.refreshTable();
			}.bind(this))
			.catch(function (error) {
				console.log(error);
			});
	},

	getListwaById: function(id) {
		for(var i in this.state.data) {
			if(this.state.data[i].id === id) {
				return this.state.data[i];
			}
		}
		return '';
	},

	refreshTable: function() {
		axios.get('http://217.182.200.222:8080/stanListwy')
		.then(function (stanListwy) {
			this.setState({data: stanListwy.data});
		}.bind(this));
	}
});

export default StanListwy;



// WEBPACK FOOTER //
// ./src/components/StanListwy/StanListwy.js